<div class="govuk-panel govuk-panel--with-icon govuk-!-width-one-half govuk-!-margin-bottom-8">
  <img class="govuk-!-margin-right-1" src="/assets/images/large-green-tick.svg" alt="successful" />
  <h1 class="govuk-heading-l">Your new password has been saved</h1>
</div>

<button type="button" class="govuk-button" (click)="backToSignInPage()">Back to sign in</button>
